import { availableLocales } from "_constants";
import includes from "lodash/includes";

import DataStorage from "./DataStorage";

const getLocale = () => {
  const userLocale = DataStorage.getUserLocale() || window.locale || navigator.language;

  return availableLocales.indexOf(userLocale) === -1 ? "en" : userLocale;
};

export const getFallbackLocale = (locale = null) =>
  (locale || getLocale()).replace("-flex", "").replace("-acquisition", "");

export const getLocales = () =>
  DataStorage.getCompanyType() !== "leasing"
    ? availableLocales.filter((l) => includes(l, DataStorage.getCompanyType()))
    : availableLocales.filter((l) => !includes(l, "flex") && !includes(l, "acquisition"));

export default getLocale;
